import { render, staticRenderFns } from "./RolesDropdown.vue?vue&type=template&id=e9fd45e2&"
import script from "./RolesDropdown.vue?vue&type=script&lang=ts&"
export * from "./RolesDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports